﻿const quantityInput = document.querySelector('.product-detail-page__qty-container input');
if (quantityInput) {

    quantityInput.onkeyup = function (event) {
        event.preventDefault();
        validation(quantityInput);
    }
}

const mobile_quantityInput = document.querySelector('.product-detail-page__top-cta-container .fx-row input');
if (mobile_quantityInput) {

    mobile_quantityInput.onkeyup = function (event) {
        event.preventDefault();
        validation(mobile_quantityInput);
    }
}

const searchQuantityInputs = document.querySelectorAll('.search-results-card__qty-container input');
if (searchQuantityInputs) {

    searchQuantityInputs.forEach(function (searchQuantityInput) {
        searchQuantityInput.onkeyup = function (event) {
            event.preventDefault();
            validation(searchQuantityInput);
        }
    });
}

const cartQtyInputs = document.querySelectorAll('.cart-items-page__cart-col-container input');
if (cartQtyInputs) {
    cartQtyInputs.forEach(function (cartQtyInput) {
        cartQtyInput.onkeyup = function (event) {
            event.preventDefault();
            validation(cartQtyInput);
        }
    });
}

function validation(input) {
    var quantity = parseInt(input.value);
 
    if (isNaN(quantity)) {
        input.style.border = "1px solid red";
        return;
    } else {
        input.style.border = "";
    }

    if (input.value <= 0) {
        input.value = 1;
    }

    if (!Number.isInteger(input.value)) {
        input.value = input.value.replace(/\D/g, '');
    }
}